export const PRICE_CHANNEL_PERSONAL_BASE = "/pc/my/pricechannel";

const SECTION_RULES = Object.freeze([
  { id: "identity", label: "频道身份", path: PRICE_CHANNEL_PERSONAL_BASE, actions: [] },
  { id: "activity", label: "消息中心", path: `${PRICE_CHANNEL_PERSONAL_BASE}/activity`, actions: [] },
  { id: "watchlists", label: "行情自选", path: `${PRICE_CHANNEL_PERSONAL_BASE}/watchlists`, actions: ["WATCHLIST_WRITE"] },
  { id: "certifications", label: "企业认证", path: `${PRICE_CHANNEL_PERSONAL_BASE}/certifications`, actions: ["CERTIFICATION_APPLY"] },
  { id: "submissions", label: "业务上报", path: `${PRICE_CHANNEL_PERSONAL_BASE}/submissions`, actions: ["SUBMISSION_WRITE"] },
  { id: "reviews", label: "审核待办", path: `${PRICE_CHANNEL_PERSONAL_BASE}/reviews`, actions: ["REVIEW", "CERTIFICATION_REVIEW", "LEADER_REVIEW"] },
  { id: "results", label: "审查结果", path: `${PRICE_CHANNEL_PERSONAL_BASE}/results`, actions: ["REVIEW", "CERTIFICATION_REVIEW", "LEADER_REVIEW"] },
]);

/** 菜单仅反映 Spring 对当前有效身份返回的动作，不推断商城 privateRole 或 Demo 角色。 */
export function allowedPriceChannelSections(context) {
  const activeId = context?.activeUserIdentityId;
  const identities = Array.isArray(context?.identities) ? context.identities : [];
  const active = identities.some((item) => item.userIdentityId === activeId);
  const actions = new Set(active && Array.isArray(context?.actions) ? context.actions : []);
  return SECTION_RULES.filter((section) =>
    section.id === "identity" || (section.id === "activity" && active) ||
    section.actions.some((action) => actions.has(action)));
}

export function canOpenPriceChannelSection(context, sectionId) {
  return allowedPriceChannelSections(context).some((section) => section.id === sectionId);
}

/** 个人中心知识百科后插入唯一价格频道菜单，未取到身份时仍保留诊断入口。 */
export function priceChannelPersonalMenu(context) {
  return {
    label: "价格频道",
    index: PRICE_CHANNEL_PERSONAL_BASE,
    icon: "data-line",
    disabled: false,
    children: allowedPriceChannelSections(context).map((section) => ({
      index: section.path,
      label: section.label,
      disabled: false,
    })),
  };
}

/** 公共导航与首页统一：保留首页，行情紧接百科；其他后台入口保持相对顺序。 */
export function withPriceChannelTopNavigation(items) {
  return withPriceChannelHomeNavigation(items);
}

/** 首页专属顺序：保留首页首位、行情紧接百科；复用后台记录，不修改接口内容或其他入口。 */
export function withPriceChannelHomeNavigation(items, normalizeUrl = item => item?.url) {
  const input = Array.isArray(items) ? items : [];
  // 接口尚未返回或无有效菜单时保持空白，不伪造“首页＋行情”的中间态。
  if (input.length === 0) return [];
  const path = item => String(normalizeUrl(item) || "").split(/[?#]/)[0].replace(/\/$/, "");
  const isHome = item => String(item?.title || "").trim() === "首页" || normalizeUrl(item) === "/" || ["/home", "/pc", "/pc/home"].includes(path(item));
  const isMarket = item => path(item) === "/pc/pricechannel/display";
  const home = input.find(isHome);
  const market = input.find(isMarket);
  const result = input.filter(item => !isHome(item) && !isMarket(item));
  result.unshift(home ? { ...home, title: "首页" } : { title: "首页", url: "/pc/home" });
  const wikiIndex = result.findIndex(item => ["/pc/wiki", "/wiki"].includes(path(item)) || ["百科", "芯片百科"].includes(item?.title));
  result.splice(wikiIndex < 0 ? 1 : wikiIndex + 1, 0,
    market ? { ...market, title: "行情" } : { title: "行情", url: "/pc/pricechannel/display" });
  return result;
}
